import React from 'react'
import { styled } from '../../stitches/stitches.config'
import { Place as PlaceType } from '../../types/Place'
import { AiOutlineRight } from 'react-icons/ai'
import { getNearPlace, meterToMinutes } from '../../api/place'

type Props = {
  groupCode: string
  places: PlaceType[]
}

const PageFeedPlaceList: React.FC<Props> = ({ groupCode, places }) => {
  return (
    <PlaceList>
      {places?.map((place) => {
        const category = place.category
          .split(' > ')
          .reverse()
          .find((item) => item !== place.name)
        const nearPlace = getNearPlace({ place, groupCode })
        return (
          <Place
            key={place.id}
            onClick={() => {
              window.open(place.placeUrl, '_blank')
            }}
          >
            <PlaceContent>
              <PlaceNameContainer>
                <PlaceName>{place.name}</PlaceName>
                <PlaceCategory>{category}</PlaceCategory>
              </PlaceNameContainer>
              <PlaceLabel>
                {[
                  `걸어서 ${meterToMinutes(place.distance)}분`,
                  nearPlace ? `${nearPlace} 근처` : '',
                ]
                  .filter((item) => !!item)
                  .join(` ${String.fromCharCode(0x00b7)} `)}
              </PlaceLabel>
            </PlaceContent>
            <PlaceMoreIconWrapper>
              <AiOutlineRight size="18px" />
            </PlaceMoreIconWrapper>
          </Place>
        )
      })}
    </PlaceList>
  )
}

export default PageFeedPlaceList

const PlaceList = styled('div', {
  margin: '18px 0 0',
})

const Place = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '18px 0 0',
  background: 'white',
  boxShadow: 'rgba(149, 157, 165, 0.2) 0px 2px 6px',
  padding: '14px 16px ',
  color: 'black',
  wordBreak: 'break-word',
  borderRadius: '8px',

  '&:first-child': {
    margin: 0,
  },
})

const PlaceContent = styled('div')

const PlaceNameContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
})

const PlaceCategory = styled('div', {
  margin: '0 0 0 4px',
  padding: '2px 4px',
  borderRadius: '2px',
  fontSize: '10px',

  background: '$red600',
  color: 'white',
  fontWeight: '700',
})

const PlaceName = styled('div', {
  fontSize: '18px',
  fontWeight: 600,
  color: '$gray900',
})

const PlaceLabel = styled('div', {
  margin: '4px 0 0',
  color: '$gray600',
  $text: 'label',
})

const PlaceMoreIconWrapper = styled('div', {
  color: '$background',
})
